// extracted by mini-css-extract-plugin
export default {"custom":"CustomScene_custom__HyaYz","custom_p":"CustomScene_custom_p__+qDlO"};